// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { taikoHekla as _taikoHekla } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the taikoHekla chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 167009
 * Chain Name: Taiko Hekla L2
 * Default Block Explorer: https://hekla.taikoscan.network
 * Default RPC URL: https://rpc.hekla.taiko.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { taikoHekla } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: taikoHekla,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const taikoHekla = createCommon({
	..._taikoHekla,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
